import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import EconomicActivityStatus from './economic-activity-status';
import EconomicActivityStatusDetail from './economic-activity-status-detail';
import EconomicActivityStatusUpdate from './economic-activity-status-update';
import EconomicActivityStatusDeleteDialog from './economic-activity-status-delete-dialog';

const EconomicActivityStatusRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<EconomicActivityStatus />} />
    <Route path="new" element={<EconomicActivityStatusUpdate />} />
    <Route path=":id">
      <Route index element={<EconomicActivityStatusDetail />} />
      <Route path="edit" element={<EconomicActivityStatusUpdate />} />
      <Route path="delete" element={<EconomicActivityStatusDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EconomicActivityStatusRoutes;
